// models component
import Folder from '@/models/Folder'

export default class FolderFetch {
    static of() {
        return Promise.resolve()
            .then(function () {
                return Folder.api()
                    .fetch()
                    .then(function (result) {
                        return result
                    })
            })
            .catch(() => {
                return new Promise((resolve, reject) => {
                    reject(new Error())
                })
            })
    }
}
